import { Permission } from "~/hooks/permissions";
import PermissionOrWarn from "~/components/common/PermissionOrWarn";
import KPIDashboardScreen from "~/components/kpis/KPIDashboardScreen";

export default function KPIDashboardView() {
  return (
    <PermissionOrWarn permission={Permission.viewKPIs}>
      <KPIDashboardScreen />
    </PermissionOrWarn>
  )
}
